import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { JobcardComponent } from '../jobcard/jobcard.component';
import { ChecklistService } from '../../../../services/checklist.service';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChecklistComponent implements OnInit {

  @Input() jobcard;
  @Input() partnerID;
  public loading: boolean = false;
  public preServiceChecklist: any = [];
  public mandatoryChecklist: any = [];
  public mandatoryBlockersChecklist: any = [];
  public linkedServiceChecklist: any = [];
  public additionalChecklist: any = [];
  public additionalChecklistMinimized: boolean = true;

  constructor(
    private checklistService: ChecklistService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.getChecklistService();
  }

  getChecklistService() {
    this.checklistService.getServiceChecklist(this.partnerID, this.jobcard.ID).subscribe(res => {
      res.forEach(item => {
        item.defaultValue = item.controlType === "CHECKBOX" && item.defaultValue === "false" ? false : item.controlType === "CHECKBOX" && item.defaultValue === "true" ? true : item.defaultValue;
        item.frontValue = item.controlType === "CHECKBOX" && item.frontValue === "false" ? false : item.controlType === "CHECKBOX" && item.frontValue === "true" ? true : item.frontValue;
        item.rearValue = item.controlType === "CHECKBOX" && item.rearValue === "false" ? false : item.controlType === "CHECKBOX" && item.rearValue === "true" ? true : item.rearValue;
      });
      console.log(res);
      this.preServiceChecklist = res.filter(x => { return x.isPreServiceCheck && !x.mandatory });
      this.mandatoryChecklist = res.filter(x => { return x.mandatoryForAllServices && !x.mandatory });
      this.mandatoryBlockersChecklist = res.filter(x => { return x.mandatory });
      this.linkedServiceChecklist = res.filter(x => { return x.linkedToServiceTypes && !x.mandatory });
      this.additionalChecklist = res.filter(x => { return !x.isPreServiceCheck && !x.mandatoryForAllServices && !x.linkedToServiceTypes && !x.mandatory });
      if (this.preServiceChecklist.length === 0 && this.mandatoryChecklist.length === 0 && this.linkedServiceChecklist.length === 0) {
        this.additionalChecklistMinimized = false;
      }
      this.loading = false;
      console.log(this.mandatoryBlockersChecklist);
    }, err => {
      this.preServiceChecklist = [];
      this.mandatoryChecklist = [];
      this.linkedServiceChecklist = [];
      this.additionalChecklist = [];
      this.loading = false;
    });
  }

  updateChecklistItem(item) {
    var data = {
      ServiceID: this.jobcard.ID,
      ChecklistConfigID: item.id,
      DefaultValue: item.defaultValue,
      FrontValue: item.frontValue,
      RearValue: item.rearValue,
      ID: item.serviceChecklistID
    };
    this.checklistService.saveServiceChecklistValue(this.partnerID, this.jobcard.ID, data).subscribe(result => {
      //this.getChecklistService();
    });
  }

}
